import { logError } from '@zg-rentals/log-error';
import { getAnalyticsErrorType } from '@zg-rentals/rentals-analytics';
import type { RentalsLead, ZrmClickstreamLead } from './types';

export function getZrmRentalsLead(lead?: ZrmClickstreamLead | null): RentalsLead {
  try {
    // Omit the renter_details block entirely when leadId is unavailable. Emitting `rentals_lead: null`
    // crashes the zOmnibug extension parser, which runs Object.keys() on any object-typed value
    // (and typeof null === 'object').
    if (!lead?.leadId) {
      return {};
    }

    return {
      rentals_lead: {
        lead_id: String(lead.leadId),
        ...(lead.listingPrice != null && { listing_price: Number(lead.listingPrice) }),
        ...(lead.zip != null && { zip: String(lead.zip) }),
        ...(lead.state != null && { state: String(lead.state) }),
        ...(lead.income != null && { income: Number(lead.income) }),
        ...(lead.creditCd != null && { credit_cd: String(lead.creditCd) }),
      },
    };
  } catch (error) {
    logError({ error, errorType: getAnalyticsErrorType('getZrmRentalsLead'), context: { argumentPassed: lead } });
    return {};
  }
}
